/* eslint-disable */
import * as utils from '@/utils/util'

export const connect = {
  tel: '025-83326233 转 8001',
  mobile: '139 5199 9893'
}

export const admin = {};
export const h5 = {};
export const pc = {};
export const help = {};
export const hogeTech = {};
export const api = {
  'wwwHost': '',
  'manageHost': ''
};


switch(utils.getEnv()) {
  case 'pre':
    {
      api.wwwHost = 'https://pre-www.duanshu.com';
      api.manageHost = 'http://pre-api.duanshu.com';
      admin.host = 'http://pre-api.duanshu.com';
      h5.host = 'http://pre-h5.duanshu.com';
      pc.host = 'http://pre-pc.duanshu.com';
      h5.secHost = 'http://{placeholder}.pre';
      help.host = 'http://help.duanshu.com';
      hogeTech.host = 'pre-my.duanshu.com';
      break;
    }
    case 'dev':
    case 'test': {
        api.wwwHost = 'http://test-www.duanshu.com';
        api.manageHost = 'http://test-api.duanshu.com';
        admin.host = 'http://test-api.duanshu.com';
        h5.host = 'http://test-h5.duanshu.com';
        pc.host = 'http://test-pc.duanshu.com';
        h5.secHost = 'https://{placeholder}.test';
        help.host = 'http://help.duanshu.com';
        hogeTech.host = 'test-my.duanshu.com';
        break;
    }
  default:
    {
      api.wwwHost = 'https://www.duanshu.com';
      api.manageHost = 'http://api.duanshu.com';
      admin.host = '//api.duanshu.com';
      h5.secHost = 'https://{placeholder}';
      h5.host = 'https://h5.duanshu.com';
      pc.host = 'https://pc.duanshu.com';
      help.host = 'http://help.duanshu.com';
      hogeTech.host = 'my.duanshu.com';
    }
}

export const qcloudSetting = {
  appid: '1253559031',
  secretId: 'AKIDc4IH0UDhT0HPIvaVSBfuvhEWaP0L5M0P',
  secretKey: 'IMBl6DsISN7bq25sPghTzELDpBJBoCLG',
  bucket_name: 'hogetech',
  dir_name: 'techapply',
  district: 'sh',
  qrcloudUrl: {
    image: 'http://{district}.file.myqcloud.com/files/v2/{appid}/{bucket_name}/{dir_name}/{type}/{file_name}',
    video: 'https://vod.qcloud.com/v2/index.php'
  }
};

export const getQcloud = (type, file_name) => {
  type = type || 'image';
  if (!qcloudSetting.qrcloudUrl[type]) {
    return false;
  }
  switch (type) {
    case 'image':
      {
        file_name = file_name || ['qcloud_upload', type].join('.');
        return qcloudSetting.qrcloudUrl[type]
          .replace(/{district}/, qcloudSetting.district)
          .replace(/{appid}/, qcloudSetting.appid)
          .replace(/{bucket_name}/, qcloudSetting.bucket_name)
          .replace(/{dir_name}/, qcloudSetting.dir_name)
          .replace(/{type}/, type)
          .replace(/{file_name}/, file_name)
        break;
      }
    case 'video':
      {
        return qcloudSetting.qrcloudUrl[type]
      }
  }
};


const constant = {
  'wwwHost': {
    article_list: '/api/admin/article',
    article_delete: '/api/admin/article/{_id}',
    article_detail: '/api/admin/article/{_id}',
    article_create: '/api/admin/article',
    article_update: '/api/admin/article/{_id}',
    article_batch_delete: '/api/admin/article/batch_delete',
    page_list: '/api/admin/page',
    page_create: '/api/admin/page',
    page_update: '/api/admin/page/{_id}',
    page_detail: '/api/admin/page/{_id}',
    page_delete: '/api/admin/page/{_id}',
    baidu_visitor_list: '/api/admin/baidu_visitor',
    baidu_visitor_detail: '/api/admin/baidu_visitor/{_id}',
    baidu_visitor_delete: '/api/admin/baidu_visitor/{_id}',
    baidu_visitor_batch_delete: '/api/admin/baidu_visitor/batch_delete',
    spider_list: '/api/admin/spider',
    access_list: '/api/admin/access',
    statistics: '/api/admin/statistics',
  },
  'manageHost': {
    login: '/admin/login',
    logout: '/admin/logout',
    captcha: '/captcha/code/', // 图形验证码
  }
};

export const getUri = (key, type) => {
  if(!api[type] || !constant[type] || !constant[type][key]) {
    return '';
  }
  return api[type] + constant[type][key];
};



// WEBPACK FOOTER //
// ./src/config/config.js